export const paymentTypes = ["virement", "espèces", "chèque"];
